import { combineReducers } from "redux";
import auth from "./auth.reducers";
import storage from "./storage.reducer";
import dashboardStates from "./dashboard.reducers";
import launchdarkly from "./launchdarkly.reducers";
import patientlist from "./patientList.reducers";
import searchpatientlist from "./searchPatient.reducers";
import teamList from "./teamList.reducers";
import patientProfile from "./profile.reducer";
import careteamList from "./careteam.reducers";
import inactivePatientlist from "./inactivePatients.reducers";
import recentSearchList from "./recentSearch.reducer";
import global from "./globals.reducers";
import library from "./library.reducer";
import content from "./content.reducer";
import Notes from "./note.reducers";
import Epic from "./epic.reducer";
import Template from "./template.reducer";

const rootReducer = combineReducers({
   auth,
   storage,
   dashboardStates,
   launchdarkly,
   patientlist,
   searchpatientlist,
   teamList,
   careteamList,
   patientProfile,
   inactivePatientlist,
   recentSearchList,
   global,
   library,
   content,
   Notes,
   Epic,
   Template,
});

export default rootReducer;
